// Загрузка MapLibre без статического импорта библиотеки: модуль лёгкий и входит в основной чанк,
// чтобы CourierMap начинал качать MapLibre, стиль и GlMap одновременно, а не цепочкой.
// Воркер MapLibre собирается Vite отдельным чанком: путь по умолчанию (new URL(…, import.meta.url))
// ломается при пре-бандлинге зависимостей в dev и не обрабатывается сборщиком в build.
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'
import { loadMapStyle } from './styles'
import type { MapTheme } from './types'

let mapLibPromise: Promise<typeof import('maplibre-gl')> | null = null

export function loadMapLib() {
  if (!mapLibPromise) {
    mapLibPromise = import('maplibre-gl').then((m) => {
      m.setWorkerUrl(workerUrl)
      return m
    })
    mapLibPromise.catch(() => {
      mapLibPromise = null
    })
  }
  return mapLibPromise
}

/** Начать загрузку всего, что нужно GL-карте; ошибки обработает GlMap (фолбэк-карта). */
export function prefetchMap(theme: MapTheme): void {
  loadMapLib().catch(() => {})
  loadMapStyle(theme).catch(() => {})
}
